export function transitionHeight(node, { isOpen, duration, easing }) {
    // Initialize height & visibility
    node.style.height = isOpen ? 'auto' : '0px';
    node.style.visibility = isOpen ? 'visible' : 'hidden';
    function open() {
        // Set inline height to computed height (if mid-transition)
        node.style.height = getComputedStyle(node).height;
        // Force element to repaint
        node.offsetHeight; // eslint-disable-line no-unused-expressions
        // Add open transition styles
        node.style.transition = `
      height ${duration} ${easing},
      visibility 0s`;
        // Transition to open height
        node.style.visibility = 'visible';
        node.style.height = `${node.scrollHeight}px`;
    }
    function close() {
        // Set inline height to computed height (if mid-transition)
        node.style.height = getComputedStyle(node).height;
        // Force element to repaint
        node.offsetHeight; // eslint-disable-line no-unused-expressions
        // Add close transition styles
        node.style.transition = `
      height ${duration} ${easing},
      visibility 0s ${duration}`;
        // Transition height to zero
        node.style.visibility = 'hidden';
        node.style.height = '0px';
    }
    // Reset height to auto when open transition ends
    function onTransitionEnd(e) {
        if (e.propertyName === 'height' && node.style.height !== '0px') {
            node.style.height = 'auto';
        }
    }
    node.addEventListener('transitionend', onTransitionEnd);
    return {
        update({ isOpen }) {
            isOpen ? open() : close();
        },
        destroy() {
            node.removeEventListener('transitionend', onTransitionEnd);
        },
    };
}
